import { render, staticRenderFns } from "./TV1.vue?vue&type=template&id=9a380c4e&scoped=true&"
import script from "./TV1.vue?vue&type=script&lang=js&"
export * from "./TV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a380c4e",
  null
  
)

export default component.exports